module.exports = __webpack_public_path__ + "./fonts/40e15ea8bd7126393f67dcca5e879172.woff2";